<div class="datepicker"
     [hidden]="!initialized">

  <input type="text"
         class="datepicker-selection form-control"
         placeholder="Select date"
         i18n-placeholder="@@communication-centre.date-picker.select-date-placeholder"
         [readonly]="true"
         [value]="formattedSelection | async"
         (click)="toggleVisibility()"/>

  <button type="button"
          class="datepicker-toggle hasDatepicker"
          (click)="toggleVisibility()"></button>

  <input type="hidden"
         ngbDatepicker
         autoClose="outside"
         [footerTemplate]="footer"
         [minDate]="pickerMinDate"
         [maxDate]="pickerMaxDate"
         [(ngModel)]="pickerDate"
         (ngModelChange)="change()"
         #picker="ngbDatepicker"/>

  <ng-template #footer>

    <hr/>

    <div *ngIf="displayTimezone"
         class="text-center mb-sm timezone">
      <span>{{ timeZoneLabel }}</span>
    </div>

    <ng-container *ngIf="allowTimeComponent">

      <div class="time-picker">
        <ngb-timepicker spinners="true"
                        [disabled]="nowSelected"
                        [meridian]="displayMeridian"
                        [(ngModel)]="pickerTime"
                        (ngModelChange)="change()">
        </ngb-timepicker>
      </div>

    </ng-container>

    <button class="btn btn-primary btn-sm m-2 action-now"
            i18n="@@communication-centre.date-picker.button.now"
            [disabled]="!nowWithinDateBoundaries"
            [ngClass]="{'btn-selected': nowSelected}"
            (click)="closeWithNow()">
      Now
    </button>

    <button class="btn btn-secondary btn-sm m-2 pull-right action-close"
            i18n="@@communication-centre.date-picker.button.close"
            (click)="close()">
      Close
    </button>

  </ng-template>

</div>
